import { v4 as uuid } from 'uuid';

import { MESSAGES } from '../../../constants';

export interface IArticleItem {
  readonly _id: string;
  readonly title: string;
  readonly subtitle?: string;
}

export interface IArticleSelector {
  readonly id: string;
  readonly type: MESSAGES.ARTICLE_SELECTOR;
  readonly items: IArticleItem[];
  readonly rm: boolean;
  readonly nodeId: string;
  readonly role?: string;
}

export const createArticleSelector = (data): IArticleSelector => ({
  id: data.id || uuid(),
  type: MESSAGES.ARTICLE_SELECTOR,
  items: data.items,
  rm: Boolean(data.rm),
  nodeId: data.nodeId,
});
